import { render, staticRenderFns } from "./mix-chart.vue?vue&type=template&id=484b0a8d&scoped=true"
import script from "./mix-chart.vue?vue&type=script&lang=js"
export * from "./mix-chart.vue?vue&type=script&lang=js"
import style0 from "./mix-chart.vue?vue&type=style&index=0&id=484b0a8d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b0a8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484b0a8d')) {
      api.createRecord('484b0a8d', component.options)
    } else {
      api.reload('484b0a8d', component.options)
    }
    module.hot.accept("./mix-chart.vue?vue&type=template&id=484b0a8d&scoped=true", function () {
      api.rerender('484b0a8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/charts/mix-chart.vue"
export default component.exports